// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const window: any;

const apiUrl = (function constructApiUrl() {
  if (window && window.env) {
    const { REACT_APP_API_URL, REACT_APP_API_VERSION } = window.env;

    return `${REACT_APP_API_URL || process.env.REACT_APP_API_URL}${
      REACT_APP_API_VERSION || process.env.REACT_APP_API_VERSION
    }`;
  }
  return `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_VERSION}`;
})();

const appMode = (function getAppMode() {
  if (window && window.env) {
    const { REACT_APP_MODE } = window.env;

    return `${REACT_APP_MODE || process.env.REACT_APP_MODE}`;
  }
  return `${process.env.REACT_APP_MODE}`;
})();

const appAccessMode = (function getAccessMode() {
  if (window && window.env) {
    const { REACT_APP_AWS_AUTH_ENABLED } = window.env;
    return `${
      REACT_APP_AWS_AUTH_ENABLED || process.env.REACT_APP_AWS_AUTH_ENABLED
    }`;
  }
  return `${process.env.REACT_APP_AWS_AUTH_ENABLED}`;
})();

const userIdType = (function getAccessMode() {
  if (window && window.env) {
    const { REACT_APP_USER_ID_TYPE } = window.env;
    return REACT_APP_USER_ID_TYPE || process.env.REACT_APP_USER_ID_TYPE;
  }
  return process.env.REACT_APP_USER_ID_TYPE;
})();

const convertToBool = (envVar: string) => envVar.toLowerCase() === 'true';

const ENVIRONMENTS = {
  dev: {
    API_BASE_URL: apiUrl,
    LOGIN_URL: null,
    APP_MODE: appMode,
    LOGIN_REQUIRED: convertToBool(appAccessMode),
    API_AUTH_TOKEN_REQUIRED: convertToBool(process.env.REACT_APP_AUTH_ENABLED),
    USER_ID_TYPE: userIdType,
  },
  test: {
    API_BASE_URL: 'test_base_url',
    LOGIN_URL: null,
    APP_MODE: appMode,
    LOGIN_REQUIRED: convertToBool(appAccessMode),
    API_AUTH_TOKEN_REQUIRED: convertToBool(process.env.REACT_APP_AUTH_ENABLED),
    USER_ID_TYPE: userIdType,
  },
  prod: {
    API_BASE_URL: apiUrl, // 'http://localhost:59820/api/v1',
    LOGIN_URL: null,
    APP_MODE: appMode,
    LOGIN_REQUIRED: convertToBool(appAccessMode),
    API_AUTH_TOKEN_REQUIRED: convertToBool(process.env.REACT_APP_AUTH_ENABLED),
    USER_ID_TYPE: userIdType,
  },
};

// Based on REACT_APP_ENV environmental variable we pick different env config
export const ENV_CONFIG = (): typeof ENVIRONMENTS.dev =>
  ENVIRONMENTS[process.env.REACT_APP_ENV as keyof typeof ENVIRONMENTS];
